<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>MerchantApp Kullanıcı Ekle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="userData.email"
            maxlength="255"
            counter="255"
            :rules="emailRules"
            @input="onEmailChange"
            @keydown.space.prevent
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="isAdmin">
          <h4>Firma</h4>
          <v-select
            v-model="userData.companyId"
            :items="allCompanyList"
            @change="companyChange"
            item-text="companyName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8" v-if="isAdmin"></v-col>

        <v-col cols="12" md="4">
          <h4>Mağaza/Tabela</h4>
          <v-select
            v-model="userData.venueId"
            :items="allVenues"
            item-text="venueName"
            item-value="id"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Rol</h4>
          <v-select
            v-model="userData.role"
            :items="roles"
            item-text="name"
            item-value="value"
            label="Seçiniz"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="userData.active" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: right; color: white;"
            @click="readerUserAdd()"
            :disabled="disabledButton"
          >
            EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="error in errorList" :key="error">{{ error }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PanelUser',
  data() {
    return {
      userData: {
        email: '',
        active: true,
        companyId: 0,
        venueId: 0,
        role: '',
      },
      isAdmin: false,
      valid: true,
      emailRules: [
        (v) => !!v || 'Email alanı zorunludur.',
        (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'Lütfen geçerli bir mail adresi giriniz.',
      ],
      errorList: [],
      dialog: false,
      roles: [
        {
          name: 'Mağaza Sahibi',
          value: 'ReaderUserVenueOwner',
        },
        {
          name: 'Barista',
          value: 'ReaderUser',
        },
      ],
      disabledButton: true,
    }
  },
  computed: mapGetters(['allVenues', 'allCompanyList']),
  created() {
    this.userRoles = JSON.parse(localStorage.getItem('userRoles'))

    if (this.userRoles.includes('PanelUser')) {
      this.isAdmin = true
    }

    if (!this.isAdmin) {
      const accessToken = localStorage.getItem('frinkUserToken')
      const payload = accessToken.split('.')[1]
      const decoder = new TextDecoder('utf-8')
      const tokenDecodeData = JSON.parse(
        decoder.decode(this.base64UrlDecode(payload)),
      )
      this.getPanelUserById(tokenDecodeData.id).then((response) => {
        this.userData.companyId = response.companyId
        this.getPanelUserVenues(response.id).then((data) => {
          this.userData.venueId = data[0].venueId
        })
      })
    } else {
      this.getCompanieList().then((response) => {
        this.userData.companyId = response[0].id
        this.getVenues(response[0].id).then((data) => {
          this.userData.venueId = data[0].id
        })
      })
    }
  },
  watch: {
    'userData.role': 'updateDisabledButton',
    'userData.companyId': 'updateDisabledButton',
    'userData.venueId': 'updateDisabledButton',
  },
  methods: {
    ...mapActions([
      'getVenues',
      'getUser',
      'getCompanieList',
      'getReaderAppUser',
      'getPanelUserVenues',
      'postAddReaderAppUser',
      'getPanelUserById',
    ]),
    companyChange(companyId) {
      this.getVenues(companyId).then((data) => {
        this.userData.venueId = data[0].id
      })
    },
    routeReaderAppUsers() {
      this.$router.push('/dashboard/users/readerAppUsers')
    },
    readerUserAdd() {
      if (this.$refs.form.validate()) {
        this.postAddReaderAppUser(this.userData)
          .then((response) => {
            if (response.processStatus === 'Success') {
              this.routeReaderAppUsers()
            } else {
              alert(response.friendlyMessage.message)
            }
          })
          .catch((err) => {
            if (err.response.data) {
              const errorKey = err.response.data.friendlyMessage.message
              if (errorKey == 'required_fields_missing') {
                alert('Zorunlu alanları kontrol ediniz.')
              } else if (errorKey == 'venue_not_found') {
                alert('Mağaza bulunamadı.')
              } else if (errorKey == 'company_not_found') {
                alert('İş yeri bulunamadı.')
              } else if (errorKey == 'reader_user_already_registered') {
                alert('Aynı email adresi ile kayıtlı kullanıcı bulunmaktadır.')
              } else {
                alert('Bir hata oluştu')
              }
            } else {
              alert('Bir hata oluştu')
            }
          })
      } else {
        this.errorList = Array.from(
          document.getElementsByClassName('v-messages__message'),
          (el) => el.innerHTML,
        )
        this.dialog = true
      }
    },
    updateDisabledButton() {
      this.disabledButton =
        !this.userData.role ||
        !this.userData.companyId ||
        !this.userData.venueId ||
        !(
          this.userData.email &&
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            this.userData.email,
          )
        )
    },
    onEmailChange(value) {
      this.userData.email = value.replace(/\s+/g, '')
      this.updateDisabledButton()
    },
    base64UrlDecode(base64Url) {
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
      return buffer
    },
  },
}
</script>
